import axios, { AxiosInstance, AxiosResponse } from "axios";
import { API_BASE_URL } from "./routes";

const defaultHeaders = {
  "Content-Type": "application/json",
};

const authHeaders = {
  // Authorization: `Bearer ${localStorage.getItem("cc-access-token")}`,
  "Content-Type": "application/json",
};

// const getBearerTokens = () => {
//   const token = localStorage.getItem("cc-access-token");
//   return token ? { Authorization: `Bearer ${token}` } : {};
// };


class HttpConfig {
  Axios: AxiosInstance;

  constructor(baseURL: string) {
    this.Axios = axios.create({
      baseURL,
      headers: { ...defaultHeaders },
    });
    this.setUpInterceptors();
  }

  setUpInterceptors() {
    this.Axios.interceptors.response.use(
      (response: AxiosResponse) => response,
      (error: any) => {
        const errorData = error?.response?.data || error;
        const errCode = error?.response?.status;

        if (errCode === 401 || errCode === 403) {
          window.location.href = "/login";
          return Promise.reject(error);
        }

        const errorObj = {
          ...errorData,
          message: errorData?.message?.includes("Already Exists")
            ? errorData?.message
            : "Operation failed. Please try again after some time.",
        };

        if (errorData.correlationId) {
          errorObj.message = `${errorObj.message}\nCode: ${errorData.correlationId}`;
        }

        if (
          errCode === 404 ||
          errCode === 500 ||
          errCode === 400 ||
          errCode === 504
        ) {
        }

        if (typeof error?.response === "undefined") {
        }

        throw error;
      }
    );
  }

  async get<T>(url: string, params = {}): Promise<T> {
    try {
      const response = await this.Axios.get(url, {
        params,withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async post<T>(url: string, data = {}): Promise<T> {
    try {
      const response = await this.Axios.post(url, data, {
        headers: authHeaders,withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async put<T>(url: string, data = {}): Promise<T> {
    try {
      const response = await this.Axios.put(url, data, {
        headers: authHeaders,withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete<T>(url: string): Promise<T> {
    try {
      const response = await this.Axios.delete(url, {withCredentials: true});
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getWithBody<T>(url: string, data = {}): Promise<T> {
    try {
      const response = await this.Axios.post(url, data, {
        headers: authHeaders,withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

// Create API instance with base URL from environment variables
const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
const apiClient = new HttpConfig(baseUrl);

export const api = axios.create({
  baseURL: API_BASE_URL, 
  withCredentials: true,
});

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: any) => {
    const errorData = error?.response?.data || error;
    const errCode = error?.response?.status;

    if (errCode === 401 || errCode === 403) {
      window.location.href = "/login";
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export const apiGet = <T>(url: string, params = {}): Promise<T> =>
  apiClient.get<T>(url, params);
export const apiPost = <T>(url: string, data = {}): Promise<T> =>
  apiClient.post<T>(url, data);
export const apiPut = <T>(url: string, data = {}): Promise<T> =>
  apiClient.put<T>(url, data);
export const apiDelete = <T>(url: string): Promise<T> =>
  apiClient.delete<T>(url);
export const apiGetWithBody = <T>(url: string, data = {}): Promise<T> =>
  apiClient.getWithBody<T>(url, data);

export { HttpConfig };
